export class AssociateWorkTypeError extends Error {

}
